// extracted by mini-css-extract-plugin
module.exports = {"simpleLayout":"styles_simpleLayout__Qn4eH","mainContent":"styles_mainContent__yFTER"};